// src/components/FAQ/FAQ.jsx
import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import faqsData from "../../data/faqs.json";
import SectionWrapper from "../SectionWrapper/SectionWrapper";

export default function FAQ() {
  const [open, setOpen] = useState({});

  useEffect(() => {
    AOS.init({});
  }, []);

  const toggle = (catIdx, faqIdx) => {
    const key = `${catIdx}-${faqIdx}`;
    setOpen((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <>
      <SectionWrapper
        id="useinkysyttya"
        aria-labelledby="faq-heading"
        role="region"
      >
        <div className="space-y-8">
          <div data-aos="fade-down">
            <h2
              id="faq-heading"
              className="text-4xl font-bold font-lobster text-joyridePurple dark:text-joyrideCyan dark:text-shadow-lg"
            >
              Usein kysyttyä
            </h2>
            <p className="mt-2 text-lg font-light text-joyrideNavy dark:text-joyrideLight">
              Verkkosivujemme usein kysytyt kysymykset vastaavat yleisimpiin
              kysymyksiin bändin tilaamisesta ja esiintymisistä.
            </p>
          </div>

          {faqsData.map((cat, catIdx) => (
            <div key={catIdx} className="space-y-4">
              <h3
                className="text-2xl font-semibold font-lobster text-joyridePurple dark:text-joyrideCyan dark:text-shadow-sm"
                data-aos="fade-right"
              >
                {cat.category}
              </h3>
              <div className="border border-gray-400 dark:border-gray-700 rounded-lg overflow-hidden">
                {cat.faqs.map((item, faqIdx) => {
                  const key = `${catIdx}-${faqIdx}`;
                  const isOpen = !!open[key];
                  const contentId = `faq-answer-${key}`;
                  const questionId = `faq-question-${key}`;

                  return (
                    <div key={key} data-aos="fade-up">
                      <button
                        onClick={() => toggle(catIdx, faqIdx)}
                        aria-expanded={isOpen}
                        aria-controls={contentId}
                        aria-labelledby={questionId}
                        className="w-full flex justify-between items-center px-4 py-3 bg-white dark:bg-joyrideSky hover:bg-joyrideLight dark:hover:bg-joyrideLight transition"
                      >
                        <span
                          id={questionId}
                          className="text-left font-normal text-lg text-joyrideNavy dark:text-joyrideNavy"
                        >
                          {item.question}
                        </span>
                        <span
                          className={`transform transition-transform duration-200 ${
                            isOpen ? "rotate-180" : ""
                          }`}
                          aria-hidden="true"
                        >
                          ▼
                        </span>
                      </button>
                      {isOpen && (
                        <div
                          id={contentId}
                          role="region"
                          aria-labelledby={questionId}
                          className="font-light px-4 py-3 text-lg bg-joyrideLight dark:bg-joyrideNavy text-joyrideNavy dark:text-joyrideLight"
                          dangerouslySetInnerHTML={{ __html: item.answer }}
                        />
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </SectionWrapper>
    </>
  );
}
